import { Container, Graphics, Text } from 'pixi.js';

interface Pop { name: string; t: number; }

// Top-right achievement pop banner — glass card with amber accent strip.
// Owns its own Pixi children + the active pop list.
export class AchievementBanner {
  bg: Graphics;
  text: Text;
  private pops: Pop[] = [];

  constructor(stage: Container) {
    this.bg = new Graphics();
    stage.addChild(this.bg);
    this.text = new Text({
      text: '',
      style: {
        fontFamily: 'Courier New', fontSize: 18, fill: 0xffcc00, fontWeight: 'bold',
        letterSpacing: 2,
        dropShadow: { color: 0xffaa00, alpha: 0.85, distance: 0, angle: 0, blur: 8 } as any,
      },
    });
    this.text.anchor.set(1, 0);
    stage.addChild(this.text);
  }

  // Push a new achievement pop with its starting timer (seconds).
  push(name: string, t: number): void {
    this.pops.push({ name, t });
  }

  pushAll(newPops: ReadonlyArray<Pop>): void {
    for (const p of newPops) this.pops.push({ name: p.name, t: p.t });
  }

  // Tick decay + render the most recent pop. Pops drop off when t <= 0.
  tick(dt: number, W: number): void {
    for (let i = this.pops.length - 1; i >= 0; i--) {
      this.pops[i].t -= dt;
      if (this.pops[i].t <= 0) this.pops.splice(i, 1);
    }
    this.bg.clear();
    if (this.pops.length === 0) {
      this.text.text = '';
      return;
    }
    const top = this.pops[this.pops.length - 1];
    this.text.text = top.name;
    this.text.x = W - 24;
    this.text.y = 22;
    const a = Math.min(1, top.t * 1.5);
    this.text.alpha = a;
    const tw = this.text.width + 32;
    const th = this.text.height + 16;
    const cx = W - 14 - tw, cy = 14;
    this.bg.roundRect(cx, cy, tw, th, 8);
    this.bg.fill({ color: 0x070716, alpha: 0.88 * a });
    this.bg.stroke({ width: 1.5, color: 0xffcc00, alpha: 0.85 * a });
    this.bg.roundRect(cx + 6, cy + 6, 3, th - 12, 1.5);
    this.bg.fill({ color: 0xffcc00, alpha: a });
  }
}
